<div style="padding: 64px; text-align: center">
  <h3>{{'errors.global.code.' + reason + '.line1' | translate}}</h3>
  <h4>{{'errors.global.code.' + reason + '.line2'| translate}}</h4>
  <h4>{{'errors.global.code.' + reason + '.line3'| translate}}</h4>
  <h4>{{'errors.global.code.' + reason + '.line4'| translate}}</h4>
</div>

